import * as Sentry from "@sentry/vue";
import type { App } from "vue";

export interface InitSentryOptions {
  enabled: boolean;
  dsn: string | undefined;
  environment: string | undefined;
  version: string;
  tracesSampleRate: number;
}

// connect to sentry to be able to log externally:
export const initSentry = (app: App, options: InitSentryOptions): void => {
  const { enabled, dsn, tracesSampleRate, environment, version } = options;

  if (!enabled) {
    return;
  }

  Sentry.init({
    app,
    dsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate,
    environment: environment ?? "unknown-env",
    // "Releases are global per organization; prefix them with something project-specific for easy differentiation"
    // https://docs.sentry.io/platforms/javascript/configuration/releases/#bind-the-version
    release: "nobl9@" + version,
  });
};
